import React, { useState, useEffect } from "react";
import { PageHeader } from "../../../Common";
import services from "../services";
import authService from "../../Common/services";
import MessageModal from "../../../UI/Modal/MessageModal";
import { LoadingSpinerComponent } from "../../../Common/loader";
import groupService from "../../Group/services";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { NetOutturnListingSchemaObject } from "../NetOutturmSchema";
import { validate } from "../../Common";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Box from "@material-ui/core/Box";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import tokenService from "../../../Common/tokenDecoder";
import { getYear } from "date-fns";

const screenCode = "NETOUTTURN";

export function NetOutturnListing(props) {
  const [groups, setGroups] = useState({});
  const [estates, setEstates] = useState({});
  const [errors, setErrors] = useState({});
  const currentDate = new Date();
  const defaultSearchMonth = `${currentDate.getFullYear()}-${String(
    currentDate.getMonth() + 1
  ).padStart(2, "0")}`;
  const [netOutturnData, setNetOutturnData] = useState({
    groupID: "0",
    estateID: "0",
    year: currentDate.getFullYear().toString(),
    month: String(currentDate.getMonth() + 1).padStart(2, "0"),
    searchMonth: defaultSearchMonth,
  });
  const [netOutturnList, setNetOutturnList] = useState([]);
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    description: "Search success",
  });
  const [isTableHidden, setIsTableHidden] = useState(true);
  const [isUpdate, setIsUpdate] = useState(false);
  const [permissionList, setPermissions] = useState({
    isAddEditEnabled: false,
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false
  });
  const [isEnable, setIsEnable] = useState(true);
  const [multipleEstates, setMultipleEstates] = useState([]);

  useEffect(() => {
    if (netOutturnData.groupID !== "0") {
      getEstatesByGroupID();
    }
  }, [netOutturnData.groupID]);

  useEffect(() => {
    getAllGroups();
    getMonthName();
    getPermissions();
  }, []);

  async function getPermissions() {
    try {
      const permissions = await authService.getPermissionsByScreen(screenCode);
      const isAuthorized = permissions.find(p => p.permissionCode === "VIEWNETOUTTURN");
      if (!isAuthorized) props.history.push("/unauthorized");

      const isAddEditEnabled = permissions.find(p => p.permissionCode === 'ADDEDITNETOUTTURN');
      const isGroupFilterEnabled = permissions.find(p => p.permissionCode === 'GROUPDROPDOWN');
      const isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode === 'OPERATIONENTITYDROPDOWN');
      setPermissions({
        ...permissionList,
        isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
        isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        isAddEditEnabled: isAddEditEnabled !== undefined,
      });

      const token = tokenService.getUserDetailsFromTokenV2();

      if (token.operationEntities.length > 0) {

        var estateArray = [];
        for (let item of Object.entries(token.operationEntities)) {
          estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
        }

        setMultipleEstates(estateArray)

        setNetOutturnData({
          ...netOutturnData,
          groupID: token.groupID
        });

      } else {
        setNetOutturnData({
          ...netOutturnData,
          groupID: token.groupID,
          estateID: token.operationEntityID
        });
      }
      setNetOutturnData((prev) => ({
        ...prev,
        groupID: token.groupID || "0",
        estateID: token.operationEntityID || "0",
      }));
      setIsUpdate(!!props.location?.data);
    } catch (error) {
      setMessageModel({
        hidden: false,
        type: "Error",
        description: "Failed to load permissions",
      });
    }
  }

  async function getAllGroups() {
    const data = await groupService.getGroupsForDropdown();
    setGroups(data);
  }

  async function getEstatesByGroupID() {
    try {
      const data = await services.getEstatesByGroupID(netOutturnData.groupID);
      setEstates(data || {});
    } catch (error) {
      setMessageModel({
        hidden: false,
        type: "Error",
        description: "Failed to load estates",
      });
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNetOutturnList([]);
    setIsTableHidden(true);

    setNetOutturnData(prev => {
      const updatedData = {
        ...prev,
        [name]: value,
        year: currentDate.getFullYear().toString(),
        month: String(currentDate.getMonth() + 1).padStart(2, "0"),
      };
      if (name === "searchMonth" && value) {
        const [year, month] = value.split("-");
        updatedData.year = year;
        updatedData.month = month;
      }
      return updatedData;
    });
    setErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[name];
      return newErrors;
    });

  };
  async function handleSearch(e) {
    e.preventDefault();
    setNetOutturnList([]);
    setIsTableHidden(true);

    const schema = Joi.object(NetOutturnListingSchemaObject).options({ allowUnknown: true });
    const errors = validate(schema, netOutturnData);
    setErrors(errors || {});
    if (errors && Object.keys(errors).length > 0) return;
    const searchParams = {
      groupID: parseInt(netOutturnData.groupID),
      estateID: parseInt(netOutturnData.estateID),
      year: netOutturnData.searchMonth ? parseInt(netOutturnData.year) : 0,
      month: netOutturnData.searchMonth ? parseInt(netOutturnData.month) : 0,
    };
    const response = await services.GetNetOutturnData(searchParams);
    if (response.data.length === 0 || response.statusCode === "Error") {
      setMessageModel({
        hidden: false,
        type: "Error",
        description: "No records found",
      });
      setTimeout(() => setMessageModel({ ...messageModel, hidden: true }), 4000);
      return;
    }

    setNetOutturnList(response.data.sort((a, b) => {
      if (a.year === b.year) return a.month - b.month;
      return a.year - b.year;
    }));
    setIsTableHidden(false);
  }


  function handleEdit(item) {
    props.history.push({
      pathname: "/NetOutturn/addEdit",
      data: {
        netOutturnID: item.outturnID,
        groupID: item.groupID ? item.groupID.toString() : "0",
        estateID: item.estateID ? item.estateID.toString() : "0",
        searchMonth: `${item.year || getYear(new Date())}-${String(item.month || 1).padStart(2, '0')}`,
        Outturn: item.outturn ? item.outturn.toString() : "",
        updatedBy: parseInt(tokenService.getUserIDFromToken()),
        isActive: item.isActive || true,
      },
    });
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }
  const getMonthName = (month) => {
    const monthNames = {
      "01": "January",
      "02": "February",
      "03": "March",
      "04": "April",
      "05": "May",
      "06": "June",
      "07": "July",
      "08": "August",
      "09": "September",
      "10": "October",
      "11": "November",
      "12": "December",
    };
    return monthNames[month] || month;
  };
  function handleCancel() {
    setNetOutturnData({
      ...netOutturnData,
      year: "",
      month: "",
      searchMonth: "",
    });
    setNetOutturnList([]);
    setIsTableHidden(true);
    setErrors({});
    props.history.push("/NetOutturn");
  };

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card">
          <PageHeader
            title="Net Outturn Listing"
            isButtonEnable={true}
            buttonText="Add Net Outturn"
            path="/NetOutturn/addEdit"
          />
          <div className="card-body">
            <form onSubmit={handleSearch}>
              <div className="form-group row">
                <div className="col-md-4 pb-1">
                  <InputLabel shrink id="groupID">
                    Group *
                  </InputLabel>
                  <Select
                    fullWidth
                    labelId="groupID"
                    id="groupID"
                    name="groupID"
                    value={netOutturnData.groupID}
                    onChange={handleChange}
                    disabled={!isEnable || !permissionList.isGroupFilterEnabled}
                  >
                    <MenuItem value="0">--Select Group--</MenuItem>
                    {Object.entries(groups).map(([key, value]) => (
                      <MenuItem key={key} value={key}>
                        {value}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.groupID && <FormHelperText error>{errors.groupID}</FormHelperText>}
                </div>
                <div className="col-md-4 pb-1">
                  <InputLabel shrink id="estateID">
                    Estate *
                  </InputLabel>
                  <Select
                    fullWidth
                    labelId="estateID"
                    id="estateID"
                    name="estateID"
                    value={netOutturnData.estateID}
                    onChange={handleChange}
                  >
                    <MenuItem value="0">--Select Estate--</MenuItem>
                    {generateDropDownMenu(multipleEstates.length == 0 ? estates : multipleEstates)}
                  </Select>
                  {errors.estateID && <FormHelperText error>{errors.estateID}</FormHelperText>}
                </div>
                <div className="col-md-4 pb-1">
                  <InputLabel shrink id="searchMonth">
                    Search Month
                  </InputLabel>
                  <TextField
                    fullWidth
                    id="searchMonth"
                    name="searchMonth"
                    type="month"
                    value={netOutturnData.searchMonth}
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  {errors.searchMonth && (
                    <FormHelperText error>{errors.searchMonth}</FormHelperText>
                  )}
                </div>
              </div>
              <div className="card-footer">
                <button type="submit" className="btn btn-primary">
                  SEARCH
                </button>
                <button
                  type="button"
                  className="btn btn-warning pull-right"
                  onClick={handleCancel}
                >
                  CLEAR
                </button>
              </div>
            </form>
            {netOutturnList.length > 0 && (
              <Box display="flex" justifyContent="flex-end" p={2} hidden={isTableHidden}>
                <TableContainer component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>
                          Estate
                        </TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>
                          Month Year
                        </TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>
                          Net Outturn
                        </TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {netOutturnList.map((row, index) => {
                        const [year, month] = netOutturnData.searchMonth.split("-");
                        return (
                          <TableRow key={index}>
                            <TableCell align="center">{row.estateName}</TableCell>
                            <TableCell align="center">
                              {`${getMonthName(String(row.month).padStart(2, '0'))} ${row.year}`}
                            </TableCell>
                            <TableCell align="center">{row.outturn}</TableCell>
                            <TableCell align="center">
                              <IconButton onClick={() => handleEdit(row)}>
                                <EditIcon color="black" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}
          </div>
        </div>
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.description}
        clicked={modalDismissHandler}
      />
      <LoadingSpinerComponent />
    </div>
  );
}